const getFocusableElements = () => {
	return "a, button:not([disabled]), input:not([type='hidden']):not([tabindex='-1']):not([style]):not([disabled]), textarea, select, [tabindex]:not([tabindex='-1'])";
};

export default getFocusableElements;
